import React, { Suspense, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Signin from "../Auth/Signin";
import { classes } from "../Data/Layouts";
import Loader from "../Layout/Loader";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import About from '../Components/Test/About'
const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [authenticated, setAuthenticated] = useState(false);

  return (
    <BrowserRouter basename={'/'}>
      <>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path={'/'} element={<PrivateRoute />}>
              <Route index element={<Navigate to={`${process.env.PUBLIC_URL}/start`} replace />} />
              <Route path={`/*`} element={<LayoutRoutes />} />
            </Route>
            {/* <Route path={`${process.env.PUBLIC_URL}/callback`} render={() => <Callback />} /> */}
            <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Signin />} />
            <Route exact path={`${process.env.PUBLIC_URL}/api/test/about`} element={<About />} />
          </Routes>
        </Suspense>
      </>
    </BrowserRouter>
  );
};

export default Routers;
